const paths = {
  dashboards: 'M3 3h7v7H3Z M14 3h7v7h-7Z M3 14h7v7H3Z M14 14h7v7h-7Z',
  evidence: 'M10 3a7 7 0 1 0 0 14 7 7 0 0 0 0-14 M15 15l6 6 M7 8h6 M7 11h4',
  "log-analysis": 'M4 3v18h17 M8 17v-4 M12 17V7 M16 17V9',
  rca: 'M5 3h14v18H5Z M8 7h8 M8 11h8 M8 15h5',
  "release-notes": 'M5 3h14v18H5Z M8 7h8 M8 11h8 M8 15h5',
  dashboard: 'M3 10 12 3l9 7v10H3Z M9 20v-7h6v7',
  chat: 'M4 4h16v12H9l-5 4Z',
  logs: 'M3 3v18h18 M6 15l4-5 4 3 6-8',
  kb: 'M12 5v16 M3 4h5l4 2 4-2h5v15h-5l-4 2-4-2H3Z',
  docs: 'M5 3h9l5 5v13H5Z M14 3v6h5 M8 13h8 M8 17h6',
  incidents: 'M12 3 2 21h20Z M12 9v5 M12 17v1',
  changes: 'M6 3v14a3 3 0 0 0 3 3h9 M18 17l3 3-3 3 M18 3v7a4 4 0 0 1-4 4H6',
  cmdb: 'M3 6c0-5 18-5 18 0s-18 5-18 0v12c0 5 18 5 18 0V6 M3 12c0 5 18 5 18 0',
  agents: 'M7 8h10l3 3v9H4v-9Z M12 3v5 M8 13v2 M16 13v2 M8 18h8',
  analytics: 'M4 21V11h4v10 M10 21V3h4v18 M16 21V7h4v14',
  users: 'M16 21v-3a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v3 M20 21v-3a4 4 0 0 0-3-4 M10 3a4 4 0 1 0 0 8 4 4 0 0 0 0-8 M17 4a4 4 0 0 1 0 7',
  billing: 'M3 5h18v14H3Z M3 10h18 M6 15h4',
  apikeys: 'M14 3a6 6 0 1 0 0 12 6 6 0 0 0 0-12 M9 13l-7 7v2h4v-3h3v-3 M16 7h.01',
  integrations: 'M8 3v5 M16 3v5 M5 8h14v4a7 7 0 0 1-14 0Z M12 19v3',
  audit: 'M5 3h14v18H5Z M8 7h8 M8 11h8 M8 15h5',
  notifs: 'M5 17h14l-2-4V8a5 5 0 0 0-10 0v5Z M10 21h4',
  settings: 'M12 8a4 4 0 1 0 0 8 4 4 0 0 0 0-8 M9 3h6l1 3 3 1 2 5-2 5-3 1-1 3H9l-1-3-3-1-2-5 2-5 3-1Z',
  search: 'M10 3a7 7 0 1 0 0 14 7 7 0 0 0 0-14 M15 15l6 6',
  refresh: 'M20 10a8 8 0 0 0-14-5L3 8 M3 3v5h5 M4 14a8 8 0 0 0 14 5l3-3 M16 16h5v5',
  menu: 'M3 6h18 M3 12h18 M3 18h18',
};
export function ConsoleIcon({ name, size = 18 }) {
  return <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><path d={paths[name] || paths.docs}/></svg>;
}
